/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EpisodeModel } from './EpisodeModel';
import {
    EpisodeModelFromJSON,
    EpisodeModelFromJSONTyped,
    EpisodeModelToJSON,
} from './EpisodeModel';
import type { FileUrl } from './FileUrl';
import { FileUrlFromJSON, FileUrlFromJSONTyped, FileUrlToJSON } from './FileUrl';

/**
 *
 * @export
 * @interface ResponseGetEpisodeApiV1EpisodesEpisodeGet
 */
export interface ResponseGetEpisodeApiV1EpisodesEpisodeGet {
    /**
     *
     * @type {any}
     * @memberof ResponseGetEpisodeApiV1EpisodesEpisodeGet
     */
    id: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetEpisodeApiV1EpisodesEpisodeGet
     */
    title: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetEpisodeApiV1EpisodesEpisodeGet
     */
    html: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetEpisodeApiV1EpisodesEpisodeGet
     */
    episodeNumber: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetEpisodeApiV1EpisodesEpisodeGet
     */
    showId: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetEpisodeApiV1EpisodesEpisodeGet
     */
    originalDate: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetEpisodeApiV1EpisodesEpisodeGet
     */
    content: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetEpisodeApiV1EpisodesEpisodeGet
     */
    shortContent: any | null;
    /**
     *
     * @type {FileUrl}
     * @memberof ResponseGetEpisodeApiV1EpisodesEpisodeGet
     */
    fileUrl?: FileUrl;
}

/**
 * Check if a given object implements the ResponseGetEpisodeApiV1EpisodesEpisodeGet interface.
 */
export function instanceOfResponseGetEpisodeApiV1EpisodesEpisodeGet(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('title' in value)) return false;
    if (!('html' in value)) return false;
    if (!('episodeNumber' in value)) return false;
    if (!('showId' in value)) return false;
    if (!('originalDate' in value)) return false;
    if (!('content' in value)) return false;
    if (!('shortContent' in value)) return false;
    return true;
}

export function ResponseGetEpisodeApiV1EpisodesEpisodeGetFromJSON(
    json: any,
): ResponseGetEpisodeApiV1EpisodesEpisodeGet {
    return ResponseGetEpisodeApiV1EpisodesEpisodeGetFromJSONTyped(json, false);
}

export function ResponseGetEpisodeApiV1EpisodesEpisodeGetFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ResponseGetEpisodeApiV1EpisodesEpisodeGet {
    if (json == null) {
        return json;
    }
    return {
        id: json['id'],
        title: json['title'],
        html: json['html'],
        episodeNumber: json['episode_number'],
        showId: json['show_id'],
        originalDate: json['original_date'],
        content: json['content'],
        shortContent: json['short_content'],
        fileUrl: json['file_url'] == null ? undefined : FileUrlFromJSON(json['file_url']),
    };
}

export function ResponseGetEpisodeApiV1EpisodesEpisodeGetToJSON(
    value?: ResponseGetEpisodeApiV1EpisodesEpisodeGet | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        id: value['id'],
        title: value['title'],
        html: value['html'],
        episode_number: value['episodeNumber'],
        show_id: value['showId'],
        original_date: value['originalDate'],
        content: value['content'],
        short_content: value['shortContent'],
        file_url: FileUrlToJSON(value['fileUrl']),
    };
}
